<template>
  <div>
    <!--彈出視窗-->
    <v-dialog
      v-model="visible"
      persistent
      :max-width="width">
      <v-card>
        <v-card-title class="headline">
          裕富官方進件
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="saveLoading === true">
          <span class="subheading">案件上傳至裕富中...請勿關閉視窗！</span>
        </v-card-text>
        <v-card-text v-if="saveLoading === false">
          <!--          <v-layout row wrap>-->
          <!--            <v-flex>-->
          <!--              <v-radio-group v-model="officialItem.tab" row>-->
          <!--                <v-radio :label="`新版`" value="1"></v-radio>-->
          <!--                <span style="color: red; margin-right: 10px;">進件請先選擇專案類型</span>-->
          <!--                <v-radio :label="`舊版`" value="0"></v-radio>-->
          <!--              </v-radio-group>-->
          <!--            </v-flex>-->
          <!--          </v-layout>-->
          <v-layout row wrap>
            <v-flex xs6>
              <v-select :items="caseTypeList"
                        item-text="text"
                        item-value="value"
                        v-model="officialItem.busType"
                        label="業務別"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="promotionList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.promotionId"
                        label="專案"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select :items="productCategoryList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productCategoryId"
                        label="商品品牌"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="productIdList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productId"
                        label="商品名稱"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field m-1
                            v-model="officialItem.contactName" :label="`經辦姓名`"
                            placeholder="輸入經辦姓名"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field m-1
                            v-model="officialItem.contactPhone" :label="`經辦電話`"
                            placeholder="輸入經辦電話"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout>
            <v-flex>
              <v-btn class="success" dark text @click="searchBankInfo">全台銀行代碼及分行表</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete :items="getBankInfo"
                              item-text="branch"
                              item-value="key"
                              v-model="officialItem.bankId"
                              :label="`撥款銀行代碼`"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="getBankSubInfo"
                              item-text="branch"
                              item-value="code"
                              v-model="officialItem.bankSubId"
                              label="`撥款銀行分行代碼`"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="officialItem.bankAccount" :label="`撥款帳號`"
                placeholder="輸入正確的帳號"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <br/>
          <v-layout v-if="isAdmin || isStaff || canEditCommissionTarget">
            <v-flex xs12 md6>
              <v-autocomplete :items="getAgents"
                              item-text="displayName"
                              item-value="agentId"
                              v-model="selectAgentId"
                              :label="`選擇撥佣的經辦`"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                v-model="officialItem.commission_target" :label="`撥佣對象`"
                placeholder="統編/身分證號"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-checkbox v-model="checkInputAssignor" label="自行輸入讓與人"></v-checkbox>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field m-1 v-if="checkInputAssignor"
                            v-model="officialItem.assignor" :label="`讓與人`"
                            placeholder="輸入讓與人姓名"></v-text-field>
              <v-autocomplete v-else :items="assignorList"
                              item-text="name"
                              item-value="assignorId"
                              v-model="selectAssignorId"
                              :label="`選擇讓與人`"
                              :loading="loadingAssignorData"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field m-1
                            v-model="officialItem.assignor_idno" :label="`讓與人ID`"
                            placeholder="輸入讓與人ID"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <br/>
          <v-layout v-if="isAdmin || isStaff || canEditCommissionTarget">
            <v-flex xs6>
              <v-text-field m-1
                            v-model="officialItem.dealerBranchNo" :label="`據點代號`"
                            placeholder="輸入據點代號"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field m-1
                            v-model="officialItem.dealerBranchName" :label="`據點名稱`"
                            placeholder="輸入據點名稱"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout>
            <v-flex>
              <v-checkbox
                v-model="zipUpload"
                :checked="zipUpload"
                label="上傳手動壓縮的檔案"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
            <span class="subheading"><span class="red--text">(*)</span>附加檔案 （可傳圖片、PDF、Zip檔案）</span>
          </v-layout>
          <upload-view :item-detail="itemDetail"
                       :is-official="true"
                       :zip-upload="zipUpload"
                       :show-upload-button="true"
                       @confirmOfficeImages="confirmOfficeImages"></upload-view>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showCancel"  class="primary" dark text :disabled="saveLoading" @click="cancelEvent">取消</v-btn>
          <v-btn class="primary" dark text :loading="saveLoading" :disabled="isSuccess" @click="save">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobileDetect from 'mobile-detect';
import productIdData from '../assets/productIdList';
import UploadView from '../components/UploadView';
import CellphoneView from '../components/CellphoneView';
import AlertView from '@/components/AlertView';
import { getZipFile } from '@/pages/utils/zip';
import AttachmentModel from '../models/AttachmentModel';
import common from '../mixins/common';

const bankCodeList = require('../assets/bank_data.json');
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'FinanceOfficialView',
  props: {
    rowItem: Object,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
    showCA20: Boolean,
  },
  components: {
    UploadView, CellphoneView, AlertView,
  },
  mixins:[common],
  data() {
    return {
      loading: false,
      selectAgentId: null,
      defaultCommissionTarget: '83657214', // 預設撥佣對象
      defaultDealerBranchNo: '0001', // 預設據點代號
      defaultDealerBranchName: '嘉好企業有限公司', // 預設據點名稱
      bankCodeList: bankCodeList,
      isSuccess: false,
      width: md.phone() ? '100%':'70%',
      saveLoading: false,
      messageDialog: {
        visible: false,
        title: '',
        content: '',
        showCancel: false,
        confirm:()=>{},
        cancel: ()=>{},
      },
      officialItem: {},
      defaultItem : {
        tab: '1',
        caseId: '',
        busType: '',
        promotionId: '',
        productCategoryId: '',
        productId: '',
        contactName: '',
        contactPhone: '',
        bankId: '',
        bankSubId: '',
        bankAccount: '',
        attachmentFiles: [],
        telCode: '',
        telPhone: '',
        telExt: '',
        companyCode: '',
        companyPhone: '',
        companyExt: '',
        guarantorTelCode: '',
        guarantorTelPhone: '',
        guarantorTelExt: '',
        guarantorCompanyCode: '',
        guarantorCompanyPhone: '',
        guarantorCompanyExt: '',
        firstContactCode: '',
        firstContactPhone: '',
        firstContactExt: '',
        firstContactCompanyCode: '',
        firstContactCompanyPhone: '',
        firstContactCompanyExt: '',
        secondContactCode: '',
        secondContactPhone: '',
        secondContactExt: '',
        secondContactCompanyCode: '',
        secondContactCompanyPhone: '',
        secondContactCompanyExt: '',
        commission_target: '',
        dealerBranchNo:'',
        dealerBranchName:'',
        assignor: '張倫彬',
        assignor_idno: 'A126611362',
      },
      checkInputAssignor: false,
      telPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      companyPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      guarantorTelPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      guarantorCompanyPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      firstContactPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      firstContactCompanyPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      secondContactPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      secondContactCompanyPhone: {
        telCode: '',
        phone: '',
        ext: '',
      },
      zipUpload: false,
      assignorList: [],
      loadingAssignorData: false,
      selectAssignorId: '',
    }
  },
  created() {
    this.officialItem = Object.assign({} , this.defaultItem);

    if (this.itemDetail.firstContact) {
      if (this.itemDetail.firstContact.homePhone.indexOf('-') > -1) {
        const split = this.itemDetail.firstContact.homePhone.split('-');
        this.firstContactPhone.telCode = split[0];
        this.firstContactPhone.phone = split[1];
      } else {
        this.firstContactPhone.phone = this.itemDetail.firstContact.homePhone;
      }

      if (this.itemDetail.firstContact.companyPhone.indexOf('-') > -1) {
        const split = this.itemDetail.firstContact.companyPhone.split('-');
        this.firstContactCompanyPhone.telCode = split[0];
        this.firstContactCompanyPhone.phone = split[1];
      } else {
        this.firstContactCompanyPhone.phone = this.itemDetail.firstContact.companyPhone;
      }
    }

    if (this.itemDetail.secondContact) {
      if (this.itemDetail.secondContact.homePhone.indexOf('-') > -1) {
        const split = this.itemDetail.secondContact.homePhone.split('-');
        this.secondContactPhone.telCode = split[0];
        this.secondContactPhone.phone = split[1];
      } else {
        this.secondContactPhone.phone = this.itemDetail.secondContact.homePhone;
      }

      if (this.itemDetail.secondContact.companyPhone.indexOf('-') > -1) {
        const split = this.itemDetail.secondContact.companyPhone.split('-');
        this.secondContactCompanyPhone.telCode = split[0];
        this.secondContactCompanyPhone.phone = split[1];
      } else {
        this.secondContactCompanyPhone.phone = this.itemDetail.secondContact.companyPhone;
      }
    }

    if (this.itemDetail.officialItem) {
      this.officialItem = this.itemDetail.officialItem;
      this.officialItem.attachmentFiles = [];
    }
  },
  watch: {
    visible (value){
      console.log('open dialog');
      console.log(`rowItem1 === ${JSON.stringify(this.rowItem)}`)

      if (value === true){
        this.officialItem.contactName = '張志成';
        this.officialItem.contactPhone = '0929009031';

        this.fetchAgentList().then(results=>{
          const current = results.find(u=>u.agentId === this.itemDetail.parentAgent.agentId);
          // console.log(`current agent ${JSON.stringify(current)}`);
          if (current) {
            // this.officialItem.contactName = current.dealerContactName ? current.dealerContactName: current.financeName;
            // this.officialItem.contactPhone = current.dealerContactPhone ? current.dealerContactPhone: current.financePhone;
            this.officialItem.commission_target = current.commissionTarget ? current.commissionTarget : this.defaultCommissionTarget;
            this.officialItem.dealerBranchNo = current.dealerBranchNo ? current.dealerBranchNo : this.defaultDealerBranchNo
            this.officialItem.dealerBranchName = current.dealerBranchName ? current.dealerBranchName : this.defaultDealerBranchName
          }
        });

        //帶入方案
        if (this.itemDetail){
          console.log(`vendor productId == ${this.itemDetail.vendor.productId }`);
          if (this.itemDetail.vendor.productId === '0'){ //原融
            this.officialItem.busType = 'AA21';
          } else if (this.itemDetail.vendor.productId === '1'){ //借新還舊
            this.officialItem.busType = 'AA22';
          } else if (this.itemDetail.vendor.productId === '2'){ //他行代償
            this.officialItem.busType = 'AA23';
          } else if (this.itemDetail.vendor.productId === '3'){ //商品原融
            this.officialItem.busType = 'CA20';
          }
          console.log(`case header == ${JSON.stringify(this.itemDetail.header)}`);
          if (this.itemDetail.header.caseType !== ''){
            if (this.officialItem.busType === 'AA21'){
              this.officialItem.promotionId = 'DN45';
            }
            if (this.officialItem.busType === 'AA22'){
              this.officialItem.promotionId = 'DM44';
            }
          }

          if (this.itemDetail.header.type[0].value === true || this.itemDetail.header.caseType4 !==''){
            if (this.officialItem.busType === 'AA22'){
              this.officialItem.promotionId = 'DM44';
            } else if (this.officialItem.busType === 'AA23'){
              this.officialItem.promotionId = 'DM66';
            } else {
              this.officialItem.promotionId = 'DN46';
            }
          }

          if (this.itemDetail.header.type[1].value === true){
            if (this.officialItem.busType === 'AA22'){
              this.officialItem.promotionId = 'DM45';
            } else if (this.officialItem.busType === 'AA23'){
              this.officialItem.promotionId = 'DM67';
            } else {
              this.officialItem.promotionId = 'DN47';
            }
          }

          if (this.showCA20){ // 商品原融
            this.officialItem.busType = 'CA20';
            this.officialItem.promotionId = 'DN48';
            this.itemDetail.vendor.productId = '3';
            this.itemDetail.vendor.productName = '商品貸';
          }
          console.log(`officialItem promotionId == ${this.itemDetail.vendor.productId} ${this.officialItem.promotionId }`);
        }
      }
    },
    selectAgentId(value){
      const find = this.getAgentList.find((e) => {
        return (  e.agentId === value );
      });
      if (find && find.commissionTarget !== ''){
        this.officialItem.commission_target = find.commissionTarget;
      }
      this.loadAssignorData();
    },
    selectAssignorId(value){
      console.log(`change selectAssignorId = ${value}`);
      const find = this.assignorList.find(a=>a.assignorId === value);
      if (find){
        this.officialItem.assignor = find.name;
        this.officialItem.assignor_idno = find.memberId;

        console.log(`assignor = ${this.officialItem.assignor}`);
        console.log(`assignor_idno = ${this.officialItem.assignor_idno}`);
      }
    },
    'officialItem.assignor'(value){
      console.log(`change assignor = ${this.officialItem.assignor}`);
    },
    'officialItem.assignor_idno'(value){
      console.log(`change assignor_idno = ${this.officialItem.assignor}`);
    }
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentList']),
    getAgents(){
      if (this.isAdmin || this.isStaff || this.isManager){
        return this.getAgentList;
      }
      return this.getAgentList.filter(agent=>agent.parentAgent.agentId === this.getUserInfo.agentId);
    },
    caseTypeList(){
      if (this.showCA20){
        return this.getCaseTypeList.filter(m=>m.key === 'CA21');
      } else {
        return this.getCaseTypeList.filter(m=>m.key !== 'CA20');
      }
    },
    promotionList() {
      if (this.showCA20){
        return this.getCAFinanceCaseList;
      } else {
        if (this.officialItem.tab === '1'){
          const list = this.getFinanceCaseList;
          return list.filter(m=> m.busType === this.officialItem.busType);
        } else {
          const list = this.getFinanceCaseList;
          return list.filter(m=> m.busType === this.officialItem.busType);
        }
      }
    },
    productCategoryList() {
      const list = this.getProductCategoryList;
      if (this.officialItem.busType === 'CA20'){
        return list.filter(m=> m.busType === this.officialItem.busType && m.key === 'commodity');
      }
      return list.filter(m=> m.busType === this.officialItem.busType);
    },
    productIdList() {
      return productIdData.list.filter(m=> m.busType === this.officialItem.busType && m.categoryId === this.officialItem.productCategoryId);
    },
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      if (this.bankCodeList[this.officialItem.bankId]){
        this.bankCodeList[this.officialItem.bankId].child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    }
  },
  methods: {
    ...mapActions(['fetchAgentList', 'saveFinanceOfficialData', 'saveToFinanceOfficial', 'saveAttachmentFile','uploadImageData'
    ,'getAssignorList']),
    save(){
      this.showDialog(true, this.$t('tip'), `※注意※【請再確認 專案別】進件後專案【無法更改】謝謝您`);
      this.messageDialog.showCancel = true;
      this.messageDialog.confirm = ()=> {
        this.messageDialog.visible = false;
        setTimeout(async ()=>{
          await this.confirmEvent();
        }, 3000);
      }
      this.messageDialog.cancel = () =>{
        this.messageDialog.visible = false;
      }
    },
    async confirmEvent() {
      this.officialItem.caseId = this.itemDetail.caseId;
      console.log(JSON.stringify(this.officialItem));
      if (this.officialItem.caseId !== '') {

        if (this.officialItem.contactName === '') {
          this.showDialog(true, '錯誤','請輸入經辦人姓名');
          return;
        }
        if (this.officialItem.contactPhone === '') {
          this.showDialog(true, '錯誤','請輸入經辦人電話');
          return;
        }

        if (this.officialItem.assignor === '' || this.officialItem.assignor_idno === '') {
          this.showDialog(true, '錯誤','請輸入讓與人姓名及身分證');
          return;
        }

        if(this.officialItem.attachmentFiles === undefined || this.officialItem.attachmentFiles.length === 0)
        {
          this.showDialog(true,
            "錯誤",
            "請選擇檔案附件！");
          return;
        }

        this.saveLoading = true;
        try {
          if (!this.zipUpload) { // 系統壓縮
            console.log(`this.editedItem.caseId ${this.itemDetail.caseId}`);
            // 壓縮檔案
            const newZip = await getZipFile(this.itemDetail.caseId, this.officialItem.attachmentFiles);
            const uploadResult = await this.uploadImageData(newZip);
            console.log(`uploadResult == ${JSON.stringify(uploadResult)}`);
            newZip.url = uploadResult;
            let attachmentItem = new AttachmentModel();
            attachmentItem.caseId = this.itemDetail.caseId;
            attachmentItem.file_index = 0;
            attachmentItem.file_body_encode = newZip.file;
            attachmentItem.file_size = `${newZip.length}`;
            attachmentItem.content_type = 'zip';
            attachmentItem.name = newZip.name;
            //程式壓縮
            this.officialItem.attachmentFiles = [
              attachmentItem
            ];

            delete newZip.image;
            delete newZip.file;
            let files = [];
            files.push(newZip);
            console.log(`attachmentFiles == ${JSON.stringify(this.officialItem.attachmentFiles)}`);
            const record = Object.assign({} , this.officialItem);
            record.attachmentFiles = files;
            console.log(`saveFinanceOfficialData == ${JSON.stringify(record)}`);
            const error = await this.saveFinanceOfficialData(JSON.parse(JSON.stringify(record))); // 紀錄
            console.log(`saveFinanceOfficialData == ${JSON.stringify(error)}`);

          } else {
            let files = [];
            for (let file of this.officialItem.attachmentFiles) {
              // await this.saveAttachmentFile(file);
              let fileItem = { name: `caseFiles/${this.officialItem.caseId}/${file.name}`,
                fileName: file.name,
                caseId: this.officialItem.caseId,
                image: file.file_body_full, url:'' };
              console.log(`== fileData ==`);
              const uploadResult = await this.uploadImageData(fileItem);
              console.log(`uploadResult ==${JSON.stringify(uploadResult)}`);
              fileItem.url = uploadResult;
              delete fileItem.image;
              files.push(fileItem);
              delete file.name;
              delete file.file_body_full;
            }
            const record = Object.assign({} , this.officialItem);
            record.attachmentFiles = files;
            console.log(`saveFinanceOfficialData == ${JSON.stringify(record)}`);
            const error = await this.saveFinanceOfficialData(record); // 紀錄
            console.log(`saveFinanceOfficialData == ${JSON.stringify(error)}`);
          }
        } catch (e){
          this.isSuccess = false;
          this.saveLoading = false;
          this.showDialog(true, '錯誤',`系統發生錯誤! 原因：${e}`);
          return;
        }

        this.officialItem.telCode = this.telPhone.telCode;
        this.officialItem.telPhone = this.telPhone.phone;
        this.officialItem.telExt = this.telPhone.ext;

        this.officialItem.companyCode = this.companyPhone.telCode;
        this.officialItem.companyPhone = this.companyPhone.phone;
        this.officialItem.companyExt = this.companyPhone.ext;

        this.officialItem.guarantorTelCode = this.guarantorTelPhone.telCode;
        this.officialItem.guarantorTelPhone = this.guarantorTelPhone.phone;
        this.officialItem.guarantorTelExt = this.guarantorTelPhone.ext;

        this.officialItem.guarantorCompanyCode = this.guarantorCompanyPhone.telCode;
        this.officialItem.guarantorCompanyPhone = this.guarantorCompanyPhone.phone;
        this.officialItem.guarantorCompanyExt = this.guarantorCompanyPhone.ext;

        this.officialItem.firstContactCode = this.firstContactPhone.telCode;
        this.officialItem.firstContactPhone = this.firstContactPhone.phone;
        this.officialItem.firstContactExt = this.firstContactPhone.ext;

        this.officialItem.firstContactCompanyCode = this.firstContactCompanyPhone.telCode;
        this.officialItem.firstContactCompanyPhone = this.firstContactCompanyPhone.phone;
        this.officialItem.firstContactCompanyExt = this.firstContactCompanyPhone.ext;

        this.officialItem.secondContactCode = this.secondContactPhone.telCode;
        this.officialItem.secondContactPhone = this.secondContactPhone.phone;
        this.officialItem.secondContactExt = this.secondContactPhone.ext;

        this.officialItem.secondContactCompanyCode = this.secondContactCompanyPhone.telCode;
        this.officialItem.secondContactCompanyPhone = this.secondContactCompanyPhone.phone;
        this.officialItem.secondContactCompanyExt = this.secondContactCompanyPhone.ext;

        try {
          if (this.rowItem && this.rowItem.agentId){
            this.itemDetail.parentAgent.agentId = this.rowItem.agentId;
          }
          this.itemDetail.officialItem = this.officialItem;
          console.log(`上傳至裕富 === ${JSON.stringify(this.itemDetail)}`);
          const resultData = await this.saveToFinanceOfficial(this.itemDetail); // 進件
          console.log(`saveToFinanceOfficial === ${JSON.stringify(resultData)}`);
          const saveResult = resultData.data;
          this.saveLoading = false;
          if (saveResult && (saveResult.statusCode === 0 || saveResult.code === 1000 || saveResult.code === '1000')) {
            this.isSuccess = true;
            this.$emit('saveSuccessEvent', saveResult);
          } else {
            this.$emit('saveFailEvent', saveResult);
          }
        } catch (e) {
          this.isSuccess = false;
          this.saveLoading = false;
          this.showDialog(true, '錯誤',`上傳至裕富發生錯誤! 原因：${(e && e.stack) || e}`);
        }
      }
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    confirmOfficeImages(files) {
      console.log(`confirmOfficeImages == ${JSON.stringify(files)}`);
      this.officialItem.attachmentFiles = files;
    },
    searchBankInfo(){
      window.open('https://www.banking.gov.tw/ch/home.jsp?id=60&parentpath=0,4&mcustomize=FscSearch_BankType.jsp&type=1',
        '_blank');
    },
    showDialog(visible, title, content) {
      this.messageDialog.visible = visible;
      this.messageDialog.title = title;
      this.messageDialog.content = content;
      this.messageDialog.conform = ()=> {
        this.dialogConfirmEvent();
      }
      this.messageDialog.cancel = () =>{
        this.messageDialog.visible = false;
      }
    },
    dialogConfirmEvent(){
      this.messageDialog.visible = false;
    },
    async loadAssignorData(){
      try {
        this.loadingAssignorData = true;
        const res = await this.getAssignorList({
          agentId: ''
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          const list = result.data;
          const filter = list.filter(assignor=>assignor.agentId === this.selectAgentId);
          if(filter.length){
            this.assignorList = filter;
          } else {
            this.assignorList = list.filter(assignor=>assignor.memberId==='A126611362');
          }
          console.log(`assignorList ${JSON.stringify(this.assignorList)}`);
        }
      } catch (e) {
        console.log(`loadAssignorData error `, e)
      } finally {
        this.loadingAssignorData = false;
      }
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FinanceOfficialView.vue